"use strict";
var makeOp_1 = require('./makeOp');
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = makeOp_1.default({
    args: ['array', 'array', 'scalar'],
    body: { args: ['a', 'b', 'f'], body: 'a=f(b)' },
    funcName: 'map',
});
//# sourceMappingURL=map.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/mesher/~/ndarray-ops-typed/lib/map.js
 ** module id = 1153
 ** module chunks = 0
 **/